import * as types from './types'

const mutations = {
  [types.MUT_SET_PRODUCT_TO_EDIT](state, product) {
    state[types.PRODUCT_TO_EDIT] = { ...product }
  },
}

export default mutations
